module.exports = __webpack_public_path__ + "static/img/color-palette-8.1dc96b2d.svg";